'use strict';

/**
 * This generates css and js that will be loaded on all pages
 */
 import { Collapse } from 'bootstrap'

import '../css/main.scss';
import LoginField from "./LoginField/LoginField";
import CookieConsent from "./CookieConsent/CookieConsent";
import NewsletterFormHandler from "./Newsletter/NewsletterFormHandler";
import Footer from "./Footer/Footer";

window.super = () => {
    new LoginField();
    new CookieConsent();
    new NewsletterFormHandler();
    new Footer();
};
